import React from 'react';
import AdCMP from './AdCMP';

const AdBanner = ({ slot, label = 'Advertisement', style = {}, className = '' }) => (
  <div className={`w-full flex flex-col items-center justify-center rounded-xl overflow-hidden bg-secondary-theme border-dashed-theme p-1.5 ${className}`}
    style={style}>
    <span className="ad-label">{label}</span>
    {/* Mobile: full width auto */}
    <div className="block md:hidden w-full">
      <AdCMP dataAdSlot={slot} />
    </div>
    {/* Tablet */}
    <div className="hidden md:block xl:hidden">
      <AdCMP adSize="468x60" dataAdSlot={slot} />
    </div>
    {/* Desktop */}
    <div className="hidden xl:block">
      <AdCMP adSize="728x90" dataAdSlot={slot} />
    </div>
  </div>
);

export default AdBanner;
